// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"815":"f06df385","913":"ed02e975","960":"81bf881d","983":"ef0a16cc"}[chunkId] + ".chunk.js";
};